export default __webpack_public_path__ + "static/media/original_oval.54548739.jpg";